// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrincipalPage_container__rrzec {
  display: flex;
  flex-direction: column;

  /* align-content: center;
  align-items: center; */
  justify-content: flex-start;
  height: 100vh;
  width: 100%;
  background-color: white;
  padding-bottom: 100px;
}

.PrincipalPage_divCuerpo__3mC0J {
  display: flex;
  flex-direction: row;
}

.PrincipalPage_sidebar__f6HTg {
  display: flex;
  top: 0;
  left: 0;
  width: 250px;
  height: 100%;
  background: white;
  color: black;
  visibility: hidden;
  padding: 1rem;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  z-index: 99;
}

.PrincipalPage_sidebar__f6HTg.PrincipalPage_open__vDJdC {
  transform: translateX(0);
  width: 250px;
  visibility: visible;
}

.PrincipalPage_sidebar__f6HTg.PrincipalPage_closed__Mhj0v {
  transform: translateX(-100%);
  width: 0px;
}

.PrincipalPage_containerMenu__UdrnS {
  margin-left: 250px;
  padding: 2rem;
  transition: margin-left 0.3s ease;
}

.PrincipalPage_listaMenu__i3hSx li {
  margin-top: 10px;
  list-style-type: none;
}

.PrincipalPage_selected__ytOpT {
  display: flex;
  font-weight: bold;
  width: 150px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  padding-bottom: 8px;
  border-radius: 8px;

  background-color: var(--primary-color-seleccionado);
}

.PrincipalPage_noSelected__IqFFS {
  display: flex;

  width: 150px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  padding-bottom: 8px;
  border-radius: 8px;

  background-color: white;
}

.PrincipalPage_itemMenu__H0mtY {
  display: flex;
  flex-direction: row;
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/PrincipalPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;EAEtB;wBACsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;;EAElB,mDAAmD;AACrD;;AAEA;EACE,aAAa;;EAEb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;;EAElB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n\n  /* align-content: center;\n  align-items: center; */\n  justify-content: flex-start;\n  height: 100vh;\n  width: 100%;\n  background-color: white;\n  padding-bottom: 100px;\n}\n\n.divCuerpo {\n  display: flex;\n  flex-direction: row;\n}\n\n.sidebar {\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 250px;\n  height: 100%;\n  background: white;\n  color: black;\n  visibility: hidden;\n  padding: 1rem;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n  z-index: 99;\n}\n\n.sidebar.open {\n  transform: translateX(0);\n  width: 250px;\n  visibility: visible;\n}\n\n.sidebar.closed {\n  transform: translateX(-100%);\n  width: 0px;\n}\n\n.containerMenu {\n  margin-left: 250px;\n  padding: 2rem;\n  transition: margin-left 0.3s ease;\n}\n\n.listaMenu li {\n  margin-top: 10px;\n  list-style-type: none;\n}\n\n.selected {\n  display: flex;\n  font-weight: bold;\n  width: 150px;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 3px;\n  padding-bottom: 8px;\n  border-radius: 8px;\n\n  background-color: var(--primary-color-seleccionado);\n}\n\n.noSelected {\n  display: flex;\n\n  width: 150px;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 3px;\n  padding-bottom: 8px;\n  border-radius: 8px;\n\n  background-color: white;\n}\n\n.itemMenu {\n  display: flex;\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PrincipalPage_container__rrzec`,
	"divCuerpo": `PrincipalPage_divCuerpo__3mC0J`,
	"sidebar": `PrincipalPage_sidebar__f6HTg`,
	"open": `PrincipalPage_open__vDJdC`,
	"closed": `PrincipalPage_closed__Mhj0v`,
	"containerMenu": `PrincipalPage_containerMenu__UdrnS`,
	"listaMenu": `PrincipalPage_listaMenu__i3hSx`,
	"selected": `PrincipalPage_selected__ytOpT`,
	"noSelected": `PrincipalPage_noSelected__IqFFS`,
	"itemMenu": `PrincipalPage_itemMenu__H0mtY`
};
export default ___CSS_LOADER_EXPORT___;
